import NormalGameManager from "../../manager/NormalGameManager";
import O1HD from "../../../../engines/gameEngine";
import {BUNDLE_SMALL_NAME, getOneBundleOnePrefab} from "../../BundleResourceConfig";
import Vec2 = cc.Vec2;
import { UIKind } from "../../../define/UIKind";
import utilsView from "../../../../engines/libs/utilsView";
import { GeneralKind } from "../../../define/GeneralKind";
import utilsModel from "../../../../engines/libs/utilsModel";

const {ccclass, property} = cc._decorator;
/**
 * 酒店预制体
 */
@ccclass
export default class SitePrefab extends cc.Component {

    @property(cc.Node)
    uiNode : cc.Node = null;
    @property({type:cc.Node})
    autoBtnNode : cc.Node = null;
    @property({type:sp.Skeleton,displayName:"搬砖人的动画"})
    peopleAni:sp.Skeleton = null;
    @property({type:cc.Node,displayName:"汽车节点"})
    carNode:cc.Node = null;
    @property({type:cc.Label,displayName:"进度文本"})
    lb_Schdule:cc.Label = null;
    @property(cc.Label)
    runTime : cc.Label = null;

    private onceAddCoin:number = 100;

    //可以点击
    private canClickFlag : boolean = true;

    private mGameLayer : NormalGameManager;
    //提示内容数组
    private noticeContentArray : string[] = [
        `宁绕百丈远，不冒一步险`,
        `安全第一，预防为主`,
        `安全人人抓，幸福千万家`,
        `小心无大错，粗心铸大错`,
        `严是爱，松是害，搞好安全利三代`,
        `质量是安全基础，安全为生产前提`,
        `安全生产，人人有责`,
    ];
    //对话下标
    private mDialogIndex : number;

    onLoad () {
        this.mGameLayer = NormalGameManager._instance;
        this.peopleAni.node.zIndex = 2;
    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.JOB);
    }

    start () {

        O1HD.getModules().uiControlModule.hideLoading();
        this.mDialogIndex = Math.floor( Math.random() * this.noticeContentArray.length );
        //开始对话
        this.onDialog();
        //判断是否有未清零的搬水泥事件
        if ( this.mGameLayer.getGameData().cementMoveSeconds ) {
            this.scheduleOnce(()=>{
                // 打开提示框
                let addCoins : number = Math.floor(this.mGameLayer.getGameData().cementMoveSeconds / 4 * this.onceAddCoin );
                O1HD.getModules().uiControlModule.showMessageBox(`自动搬砖剩余金额${ addCoins }`);
                O1HD.getServices().userSrv.setCoins( addCoins , true , this.carNode );
                this.mGameLayer.setGameData({ cementMoveSeconds : 0 } , false );
            });
        }
        this.updateSchdule();

        utilsView.enterLayerDispose(UIKind.UILayerTag.JOB, this.node);
    }

    /**
     * 说话
     */
    onDialog(){
        if( this.mDialogIndex >= this.noticeContentArray.length ){
            this.mDialogIndex = 0;
        }
        // this.lbDesc.string = this.noticeContentArray[this.mDialogIndex++];
        // this.lbDesc.node.opacity = 255;
        // this.lbDesc.node.parent.active = true;
        // //
        // this.workerSp.setAnimation( 0 , "animation", false );
        // this.scheduleOnce(()=>{
        //     cc.tween(this.lbDesc.node)
        //         .to( 0.2 , {opacity:100})
        //         .call(()=>{
        //             this.lbDesc.node.parent.active = false;
        //             let seconds : number = Math.floor( Math.random() * 5 ) + 2;
        //             this.scheduleOnce(()=>{
        //                this.onDialog();
        //             },seconds );
        //         })
        //         .start();
        // }, 3 );
    }

    /**
     * 打开鸡场预制体
     */
    async onBtnOpenChickenPrefab(){
        // O1HD.getManagers().soundMgr.playSound("anNiu").then();
        // O1HD.getManagers().soundMgr.stopMusic();
        // let prefab = await getOneBundleOnePrefab( BUNDLE_SMALL_NAME.chickenBundle, "prefab/chickenNode" );
        // let chickenNode = cc.instantiate( prefab );
        // this.node.addChild( chickenNode );
    }

    //菜地
    private cdCount : number = 0;

    //最后一次点击时间 用来判断是否是连点
    private lastClickTime:number = 0;

    /**
     * 搬砖
     */
    onBtnExpress(){
        //如果砖块数量大于十块则直接跳过
        if(this.cdCount >= 10){
            return;
        }
        //如果当前不可以点击则直接跳过
        if ( this.canClickFlag == false ) {
            return;
        }
        // 如果是自动搬砖则跳过
        if(this.mGameLayer.getGameData().cementMoveSeconds > 0){
            return;
        }

        this.firstJob();
        
        this.canClickFlag = false;
        let time = Date.now() - this.lastClickTime;
        if(this.lastClickTime == 0){
            time = 1000;
        }
        console.log(time);
        if(time < 150){
            //判断是连点
            
            this.cdCount ++;
            this.fastExpress().then(()=>{
                this.canClickFlag = true;
                this.lastClickTime = Date.now();
            });
        }else{
            //是普通点击
            
            this.cdCount ++;
            this.normalExpress().then(()=>{
                this.canClickFlag = true;
                this.lastClickTime = Date.now();
            });
        }
    }

    async normalExpress(){
        return new Promise<void>(resolve=>{
            this.peopleAni.setAnimation(0,"01_S",false);
            this.peopleAni.setCompleteListener(async ()=>{
                this.peopleAni.setAnimation(0,"Idle",true);
                this.peopleAni.setCompleteListener(null);
                await this.addOneExpress();
                resolve();
            });
        });
    }

    //快速搬砖
    async fastExpress(){
        return new Promise<void>(resolve=>{
            this.peopleAni.setAnimation(0,"01_Q",false);
            this.peopleAni.setCompleteListener(async ()=>{
                this.peopleAni.setCompleteListener(null);
                this.peopleAni.setAnimation(0,"Idle",true);
                await this.addOneExpress();
                resolve();
            });
        });
    }

    updateSchdule(){
        this.lb_Schdule.string = `${this.cdCount * 10 } / 100`;
    }

    //增加一块砖块
    addOneExpress(){
        return new Promise<void>(resolve=>{
            this.updateBrickNode();
            this.updateSchdule();
            if(this.cdCount >= 10){
                // 车子装满，车子开出去
                O1HD.getServices().userSrv.setCoins( this.onceAddCoin , true , this.carNode );
                cc.tween(this.carNode).to(0.65,{x:600}).call(()=>{
                    this.carNode.zIndex = 3;
                    this.cdCount = 0;
                    this.updateSchdule();
                    this.updateBrickNode();
                }).to(0.35,{x:200}).call(()=>{
                    this.carNode.zIndex = 1;
                    resolve();
                }).start();
            }else{
                resolve();
            }
        });
    }

    updateBrickNode(){
        let brickLayout:cc.Node = this.carNode.getChildByName("car").getChildByName("brickLayout");
        brickLayout.children.forEach((n:cc.Node,index:number)=>{
            if(index < this.cdCount){
                n.active = true;
            }else{
                n.active = false;
            }
        });
    }

    //自动加砖
    async autoAddOneExpress(){
        if(this.mGameLayer.getGameData().cementMoveSeconds <= 0){
            return;
        }
        if(this.cdCount >= 10){
            return;
        }
        this.cdCount ++;
        await this.fastExpress();
        this.autoAddOneExpress();
    }

    firstJob() {
        let gameData = NormalGameManager._instance.getGameData();
        if (!gameData.bFirstJob) {
            gameData.bFirstJob = true;
            NormalGameManager._instance.writeGameData();
            NormalGameManager._instance.addOneWeChatTriggerLinkUnShift(GeneralKind.TriggerChatId.FIRST_JOB);
        }
    }

    /**
     * 自动
     */
    onBtnAuto(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.firstJob();

        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.mGameLayer.getGameData().cementMoveSeconds = 60;
            this.runTime.node.active = true;
            this.autoBtnNode.active = false;
            this.runTime.node.parent.active = true;
            let runTime = 60;
            let clcyeCount:number = 60;
            let minute = runTime >= 60 ? Math.floor(runTime / 60) : 0
            let second = runTime >= 60 ? runTime % 60 : runTime
            this.runTime.string = (minute < 10 ? "0" + minute : minute) + ":" + (second < 10 ? "0" + second : second);
            this.schedule(()=>{
                runTime--;
                this.mGameLayer.setGameData({cementMoveSeconds:runTime} , false );
                minute = runTime >= 60 ? Math.floor(runTime / 60) : 0
                second = runTime >= 60 ? runTime % 60 : runTime
                this.runTime.string = (minute < 10 ? "0" + minute : minute) + ":" + (second < 10 ? "0" + second : second);
                if (runTime <= 0) {
                    this.mGameLayer.getGameData().cementMoveSeconds = 0;
                    this.runTime.node.parent.active = false;
                    this.runTime.node.active = false;
                    this.autoBtnNode.active = true;
                    this.canClickFlag = true;
                    this.unscheduleAllCallbacks();
                    this.peopleAni.setAnimation(0,"Idle",true);
                }
            },1,clcyeCount);
            this.autoAddOneExpress();
        },()=>{
            O1HD.getModules().uiControlModule.showMessageBox("观看视频失败");
        },()=>{

        },"自动搬水泥");
    }

    /**
     * 退出
     */
    onBtnExit(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.node.destroy();
        this.node.removeFromParent();
        // cc.tween( this.node ).to(.5,{scale:0},{easing:cc.easing.backIn}).call(()=>{
        //
        // }).start();
    }

}
